module.exports = __webpack_public_path__ + "static/img/t-shirt_left_red.01ddd5c8.png";